import type { FormatterArgs } from '@/services/types/formatter';

export default ({ data }: FormatterArgs) => {
  const profit = Number(data['reports-profit'] ?? 0);

  if (profit < 0) {
    return { kind: 'profit-status', variant: 'danger' };
  }

  if (profit > 0) {
    return { kind: 'profit-status', variant: 'success' };
  }

  return { kind: 'profit-status', variant: 'gray' };
};
